import React, { useState } from 'react';
import { Box, Button, IconButton, Drawer, List, ListItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';

const scrollItems = ['Solutions', 'Services', 'About', 'Contact'];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === '/';

  return (
    <>
        <Box
        component="nav"
        sx={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200,
          px: { xs: 2, md: 5 }, py: { xs: 0.5, md: 1 },
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          background: 'rgba(255,255,255,0.95)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(0,0,0,0.07)',
          transition: 'all 0.35s ease',
        }}
      >
        {/* Mobile: hamburger left, logo center, spacer right */}
        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
          <IconButton sx={{ color: '#6366F1', visibility: 'visible' }} onClick={() => setMobileOpen(true)}>
            <MenuIcon />
          </IconButton>
          <Box onClick={() => isHome ? window.scrollTo({ top: 0, behavior: 'smooth' }) : navigate('/')} sx={{ cursor: 'pointer' }}>
            <img src="/new-logo.png" alt="InfyniHub" style={{ height: '113px', objectFit: 'contain' }} />
          </Box>
          <Box sx={{ width: 40 }} />{/* spacer to balance hamburger */}
        </Box>

        {/* Desktop: logo left, nav center, CTA right */}
        <Box onClick={() => isHome ? window.scrollTo({ top: 0, behavior: 'smooth' }) : navigate('/')} sx={{ cursor: 'pointer', display: { xs: 'none', md: 'flex' } }}>
          <img src="/new-logo.png" alt="InfyniHub" style={{ height: '113px', objectFit: 'contain' }} />
        </Box>

        {/* Pill nav */}
        <Box sx={{
          display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 0.5,
          bgcolor: 'rgba(248,249,255,0.95)', border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: '100px', px: 1, py: 0.75, backdropFilter: 'blur(12px)',
        }}>
          <Button
            onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            sx={{ color: isHome ? '#6366F1' : '#4B5563', fontWeight: isHome ? 700 : 500, fontSize: '0.85rem', px: 2.5, py: 0.8, borderRadius: '100px', textTransform: 'none', '&:hover': { color: '#6366F1', bgcolor: 'rgba(99,102,241,0.06)' }, transition: 'all 0.2s' }}
          >
            Home
          </Button>
          {scrollItems.map((item) => (
            isHome ? (
              <Link key={item} to={item.toLowerCase()} smooth duration={600} offset={-80}>
                <Button sx={{ color: '#4B5563', fontWeight: 500, fontSize: '0.85rem', px: 2.5, py: 0.8, borderRadius: '100px', textTransform: 'none', '&:hover': { color: '#6366F1', bgcolor: 'rgba(99,102,241,0.06)' }, transition: 'all 0.2s' }}>{item}</Button>
              </Link>
            ) : (
              <Button key={item} onClick={() => navigate(`/#${item.toLowerCase()}`)} sx={{ color: '#4B5563', fontWeight: 500, fontSize: '0.85rem', px: 2.5, py: 0.8, borderRadius: '100px', textTransform: 'none', '&:hover': { color: '#6366F1', bgcolor: 'rgba(99,102,241,0.06)' }, transition: 'all 0.2s' }}>{item}</Button>
            )
          ))}
          <Button onClick={() => navigate('/blogs')} sx={{ color: location.pathname.startsWith('/blogs') ? '#6366F1' : '#4B5563', fontWeight: location.pathname.startsWith('/blogs') ? 700 : 500, fontSize: '0.85rem', px: 2.5, py: 0.8, borderRadius: '100px', textTransform: 'none', '&:hover': { color: '#6366F1', bgcolor: 'rgba(99,102,241,0.06)' }, transition: 'all 0.2s' }}>Blogs</Button>
        </Box>

        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
          {location.pathname === '/' ? (
            <Link to="contact" smooth duration={600} offset={-80}>
              <Button sx={{
                bgcolor: '#6366F1', color: '#fff', fontWeight: 700,
                px: 3, py: 1, borderRadius: '8px', textTransform: 'none', fontSize: '0.85rem',
                '&:hover': { bgcolor: '#5254CC', transform: 'translateY(-1px)', boxShadow: '0 4px 16px rgba(99,102,241,0.35)' },
                transition: 'all 0.25s',
              }}>Get Started</Button>
            </Link>
          ) : (
            <Button onClick={() => { navigate('/'); setTimeout(() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 300); }} sx={{
              bgcolor: '#6366F1', color: '#fff', fontWeight: 700,
              px: 3, py: 1, borderRadius: '8px', textTransform: 'none', fontSize: '0.85rem',
              '&:hover': { bgcolor: '#5254CC', transform: 'translateY(-1px)', boxShadow: '0 4px 16px rgba(99,102,241,0.35)' },
              transition: 'all 0.25s',
            }}>Get Started</Button>
          )}
        </Box>

      </Box>

      <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
        <Box sx={{ width: 280, bgcolor: '#FFFFFF', height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, py: 2.5, borderBottom: '1px solid rgba(0,0,0,0.07)' }}>
            <img src="/new-logo.png" alt="InfyniHub" style={{ height: '95px', objectFit: 'contain' }} />
            <IconButton onClick={() => setMobileOpen(false)} sx={{ color: '#6B7280' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List sx={{ px: 2, pt: 2 }}>
            <ListItem disablePadding sx={{ mb: 0.5 }}>
              <Button fullWidth onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); setMobileOpen(false); }} sx={{ justifyContent: 'flex-start', color: isHome ? '#6366F1' : '#374151', fontWeight: isHome ? 700 : 600, fontSize: '1rem', py: 1.5, px: 2, borderRadius: '10px', textTransform: 'none', '&:hover': { bgcolor: 'rgba(99,102,241,0.06)', color: '#6366F1' } }}>Home</Button>
            </ListItem>
            {scrollItems.map((item) => (
              <ListItem key={item} disablePadding sx={{ mb: 0.5 }}>
                {location.pathname === '/' ? (
                  <Link to={item.toLowerCase()} smooth duration={600} offset={-80} style={{ width: '100%' }} onClick={() => setMobileOpen(false)}>
                    <Button fullWidth sx={{ justifyContent: 'flex-start', color: '#374151', fontWeight: 600, fontSize: '1rem', py: 1.5, px: 2, borderRadius: '10px', textTransform: 'none', '&:hover': { bgcolor: 'rgba(99,102,241,0.06)', color: '#6366F1' } }}>{item}</Button>
                  </Link>
                ) : (
                  <Button fullWidth onClick={() => { navigate(`/#${item.toLowerCase()}`); setMobileOpen(false); }} sx={{ justifyContent: 'flex-start', color: '#374151', fontWeight: 600, fontSize: '1rem', py: 1.5, px: 2, borderRadius: '10px', textTransform: 'none', '&:hover': { bgcolor: 'rgba(99,102,241,0.06)', color: '#6366F1' } }}>{item}</Button>
                )}
              </ListItem>
            ))}
            <ListItem disablePadding sx={{ mb: 0.5 }}>
              <Button fullWidth onClick={() => { navigate('/blogs'); setMobileOpen(false); }} sx={{ justifyContent: 'flex-start', color: location.pathname.startsWith('/blogs') ? '#6366F1' : '#374151', fontWeight: 600, fontSize: '1rem', py: 1.5, px: 2, borderRadius: '10px', textTransform: 'none', '&:hover': { bgcolor: 'rgba(99,102,241,0.06)', color: '#6366F1' } }}>Blogs</Button>
            </ListItem>
          </List>
          <Box sx={{ mt: 'auto', p: 3 }}>
            {location.pathname === '/' ? (
              <Link to="contact" smooth duration={600} offset={-80} onClick={() => setMobileOpen(false)}>
                <Button fullWidth sx={{ bgcolor: '#6366F1', color: '#fff', py: 1.5, borderRadius: '10px', fontWeight: 700, textTransform: 'none', fontSize: '0.95rem', '&:hover': { bgcolor: '#5254CC' } }}>Get Started</Button>
              </Link>
            ) : (
              <Button fullWidth onClick={() => { setMobileOpen(false); navigate('/'); setTimeout(() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 300); }} sx={{ bgcolor: '#6366F1', color: '#fff', py: 1.5, borderRadius: '10px', fontWeight: 700, textTransform: 'none', fontSize: '0.95rem', '&:hover': { bgcolor: '#5254CC' } }}>Get Started</Button>
            )}
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;
